export default "__VITE_ASSET__5fb7fe43__"